export default __webpack_public_path__ + "static/media/new_logo.161acf49.png";